// import {
//   PAGE_DASHBOARD,
// } from "@/shared/constants";
import {
  TbReceipt,
  TbTruck,
  TbBuilding,
  TbUsers,
  TbSettings,
  TbBuildingStore,
  TbShield,
  TbCash,
  TbDashboard,
  TbPackage,
  TbShoppingCart,
  TbMinus,
} from "react-icons/tb";
import { type ISidebarRoute } from "../types/sidebar.types";

export const sidebarRoutes: ISidebarRoute[] = [
  {
    icon: <TbReceipt size={20} />,
    title: "Kassa",
    path: "/cashbox",
    translate: "KASSA",
    role: "_id",
    items: [
      // {
      //   icon: <TbBuildingStore size={16} />,
      //   title: "Asosiy kassa",
      //   path: "/cashbox/main",
      //   translate: "MAIN_CASHBOX",
      //   role: "getCashbox",
      // },
      // {
      //   icon: <TbShield size={16} />,
      //   title: "Obyektlar kassasi",
      //   path: "/cashbox/object",
      //   translate: "OBJECT_CASHBOX",
      //   role: "getCashbox",
      // },
      {
        icon: <TbReceipt size={20} />,
        title: "Kassa",
        path: "/cashbox/main",
        translate: "CASHBOX",
        role: "transaction",
      },
      {
        icon: <TbShield size={16} />,
        title: "Hisob-faktura",
        path: "/cashbox/invoice",
        translate: "INVOICE_CASHBOX",
        role: "_id",
      },
    ]
  },
  {
    icon: <TbTruck size={20} />,
    title: "Yetkazb beruvchi",
    path: "/delivery",
    translate: "SUPPLIER",
    role: "supplier",
  },
  {
    icon: <TbBuilding size={20} />,
    title: "Obyektlar",
    path: "/object",
    translate: "OBJECTS",
    role: "_id",
  },
  {
    icon: <TbPackage size={20} />,
    title: "Mahsulotlar",
    path: "/products",
    translate: "PRODUCTS",
    role: "product",
  },
  {
    icon: <TbShoppingCart size={20} />,
    title: "Xarid",
    path: "/purchase",
    translate: "PURCHASE",
    role: "purchase",
  },
  {
    icon: <TbMinus size={20} />,
    title: "Mahsulot chiqimi",
    path: "/write-off",
    translate: "WRITE_OFF",
    role: "write_off",
  },
  // {
  //   icon: <TbDashboard size={20} />,
  //   title: "Mahsulot hisobotlari",
  //   path: "/product-reports/pagin",
  //   translate: "PRODUCT_REPORTS",
  //   role: "_id",
  // },
  {
    icon: <TbUsers size={20} />,
    title: "Xodimlar",
    path: "/employees",
    translate: "EMPLOYEES",
    role: "employee",
    items: [
      {
        icon: <TbBuildingStore size={16} />,
        title: "Obyekt xodimlari",
        path: "/employees/object",
        translate: "OBJECT_EMPLOYEES",
        role: "employee",
      },
      {
        icon: <TbShield size={16} />,
        title: "Admin foydalanuvchi",
        path: "/employees/admin",
        translate: "ADMIN_USER",
        role: "employee",
      },
      {
        icon: <TbCash size={16} />,
        title: "Obnalchilar",
        path: "/employees/exchanger",
        translate: "CASHIERS",
        role: "employee",
      },
    ]
  },
  {
    icon: <TbPackage size={20} />,
    title: "Ombor",
    path: "/product-warehouse",
    translate: "WAREHOUSE",
    role: "product_warehouse",
    items: [
      {
        icon: <TbPackage size={16} />,
        title: "Ombordagi mahsulotlar",
        path: "/product-warehouse/stock-products",
        translate: "WAREHOUSE_STOCK_PAGING",
        role: "product_warehouse",
      },
      {
        icon: <TbPackage size={16} />,
        title: "Mahsulot narxi",
        path: "/product-warehouse/cost/paging",
        translate: "WAREHOUSE_COST_PAGING",
        role: "product_warehouse",
      },
      {
        icon: <TbPackage size={16} />,
        title: "Ombordagi mahsulotlar ro'yxati",
        path: "/product-warehouse/stock-list",
        translate: "WAREHOUSE_STOCK",
        role: "product_warehouse",
      },
      {
        icon: <TbPackage size={16} />,
        title: "Ishlatilgan mahsulotlar",
        path: "/product-warehouse/used",
        translate: "WAREHOUSE_USED",
        role: "product_warehouse",
      },
    ]
  },
  {
    icon: <TbSettings size={20} />,
    title: "Sozlamalar",
    path: "/settings",
    translate: "SETTINGS",
    role: "_id",
    items: [
      {
        icon: <TbBuildingStore size={16} />,
        title: "To'lov usullari",
        path: "/settings/payment-types",
        translate: "PAYMENT_TYPES",
        role: "payment_method",
      },
      {
        icon: <TbShield size={16} />,
        title: "Valyutalar",
        path: "/settings/currencies",
        translate: "CURRENCIES",
        role: "currency",
      },
      {
        icon: <TbCash size={16} />,
        title: "Transaksiya turi",
        path: "/settings/categories",
        translate: "TRANSACTION_TYPES",
        role: "transaction_type",
      },
      {
        icon: <TbCash size={16} />,
        title: "Rollar",
        path: "/settings/roles",
        translate: "ROLES",
        role: "role",
      },
      {
        icon: <TbCash size={16} />,
        title: "O'lchamlar",
        path: "/settings/measures",
        translate: "MEASURES",
        role: "unit_of_measure",
      },
    ]
  },
];

export const sidebarTeacherRoutes: ISidebarRoute[] = [

].filter(Boolean) as ISidebarRoute[];
